export enum FrequencyEnum {
  MILD = 'MILD',
  MODERATE = 'MODERATE',
  HIGH = 'HIGH'
}
